export default __webpack_public_path__ + "static/ocean-2cb4239203bfe77896a8e00f4437fcf5.mp4";